export const TherapyNote = (props: any) => {
  const { gender, age, symptoms, notes } = props;
  return (
    <div className="col-sm-6">
      <table className="table table-striped border-0 mt-4">
        <tbody>
          <tr>
            <th scope="row">Gender:</th>
            <td>{gender}</td>
          </tr>
          <tr>
            <th scope="row">Age:</th>
            <td>{age}</td>
          </tr>
          <tr>
            <th scope="row">Symptoms:</th>
            <td>{symptoms}</td>
          </tr>
          <tr>
            <th scope="row">Notes:</th>
            <td>{notes}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
